var locales = require('./locales.json')
var template = require('./index.html')
var t = require('../translate')

module.exports = {
  data: data,
  compiled: function() {
  },
  template: template,
  components: {
  },
  methods: {
    t: function(v) {
      return t(locales, v);
    }
  }
}

function data () {
  return {
    shops: [
      {
        address: [
          "Schamanenstube",
        ],
        web: 'http://schamanenstube.com/shop/die-halle-der-runen-karten.html',
        desc: 'Website'
      }/*,
      {
        address: [
          "Zwischenwelt",
          "6003 Luzern"
        ],
        web: 'http://www.zwischenwelt.ch',
        desc: 'Website'
      }*/
    ]
  }
}


// WEBPACK FOOTER //
// ./lib/shops/index.js